import { takeLatest, select, put } from 'redux-saga/effects';
import { Actions } from '@grandvisionhq/configurator';
import { IntlSelectors } from '@grandvisionhq/state';
import { dispatchTrackEvent, dispatchTrackErrorEvent } from '@grandvisionhq/svc-tealium/events';
import { fetchLensTypesFailed, fetchPackagesFailed, fetchAddOnsFailed } from '../bundles/actions.js';
import { getBundlePrice, getSelectedAddOn, getFrameSku, getSelectedFrameProductType } from '../configurator/selectors.js';
import '../add-to-cart/selectors.js';
import '../bundles/selectors.js';
import '../bundles/reducer.js';
import '../configurator/reducer.js';
import '../products/selectors.js';
import '../products/reducer.js';
import { tealiumRxConfiguratorViewStep } from './actions.js';
import { mapProductToTealiumImpressionProperties } from './mappers/map-product-to-tealium-impression-properties.js';
import { getConfigFlow, getProduct } from './selectors.js';

function* onTealiumConfiguratorViewStep({ payload  }) {
    yield dispatchTrackEvent(()=>Promise.resolve(payload)
    );
}
function* onConfiguratorViewStep({ payload  }) {
    const configFlow = yield select(getConfigFlow, payload);
    // Not all view steps are required to fire a Tealium event.
    // If there is no Tealium step name defined for the step, it can be ignored
    if (!(configFlow === null || configFlow === void 0 ? void 0 : configFlow.stepName)) return;
    const bundlePrice = yield select(getBundlePrice, payload);
    const selectedAddOn = yield select(getSelectedAddOn);
    const product = yield select(getProduct);
    const activeSku = yield select(getFrameSku);
    const productType = yield select(getSelectedFrameProductType);
    const locale = yield select(IntlSelectors.getLocale);
    const tealiumPayload = mapProductToTealiumImpressionProperties(configFlow, product, activeSku, productType, bundlePrice, selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.sku, locale);
    if (tealiumPayload) {
        yield put(tealiumRxConfiguratorViewStep(tealiumPayload));
    }
}
function* onFetchLensTypesFailed({ payload  }) {
    const { lensTypeSku , skus , error  } = payload;
    const errorDetails = {
        Error_Source: 'Server',
        Error_Code: 'RX panel',
        Error_Details: `Failed to fetch lens types for frame ${lensTypeSku} (SKUs: ${[
            ...skus
        ].join(', ')})`,
        Error_Message: error.message
    };
    yield dispatchTrackErrorEvent(()=>Promise.resolve(errorDetails)
    );
}
function* onFetchPackagesFailed({ payload  }) {
    const { lensTypeSku , skus , error  } = payload;
    const errorDetails = {
        Error_Source: 'Server',
        Error_Code: 'RX panel',
        Error_Details: `Failed to fetch packages for lens type ${lensTypeSku} (SKUs: ${[
            ...skus
        ].join(', ')})`,
        Error_Message: error.message
    };
    yield dispatchTrackErrorEvent(()=>Promise.resolve(errorDetails)
    );
}
function* onFetchAddOnsFailed({ payload  }) {
    const { packageSku , skus , error  } = payload;
    const errorDetails = {
        Error_Source: 'Server',
        Error_Code: 'RX panel',
        Error_Details: `Failed to fetch add-ons for package ${packageSku} (SKUs: ${[
            ...skus
        ].join(', ')})`,
        Error_Message: error.message
    };
    yield dispatchTrackErrorEvent(()=>Promise.resolve(errorDetails)
    );
}
const getTealiumSagas = (id)=>{
    return [
        takeLatest(tealiumRxConfiguratorViewStep.type, onTealiumConfiguratorViewStep),
        takeLatest(Actions.isStepShownWithId(id), onConfiguratorViewStep),
        takeLatest(fetchLensTypesFailed.type, onFetchLensTypesFailed),
        takeLatest(fetchPackagesFailed.type, onFetchPackagesFailed),
        takeLatest(fetchAddOnsFailed.type, onFetchAddOnsFailed), 
    ];
};

export { getTealiumSagas, onConfiguratorViewStep, onFetchAddOnsFailed, onFetchLensTypesFailed, onFetchPackagesFailed, onTealiumConfiguratorViewStep };
//# sourceMappingURL=sagas.js.map
